import styled from '@emotion/styled';
import { transparentize } from 'color2k';
import { Text, TextShade } from '~/shared/components';
import { breakpoints } from '$theme';
import { switchProp } from 'styled-tools';

type StyledM70Props = {
    textShade: TextShade;
};

export const StyledM70 = styled.div<StyledM70Props>(({ theme, textShade = 'paragraph' }) => ({
    position: 'relative',
    width: '100%',
    boxSizing: 'border-box',
    display: 'grid',
    gridAutoFlow: 'column',
    gridTemplateColumns: `repeat(${theme.gridConfig.columnCount.md}, 1fr)`,
    gap: theme.gridConfig.gap,
    color: transparentize(theme.text.color[textShade], 0.1),
}));

export const StyledGrid = styled.div<{ mediaType: string }>(
    {
        gridColumn: '1 / span 12',
        aspectRatio: '5 / 4',
    },
    switchProp('mediaType', {
        video: () => ({
            [breakpoints.md]: {
                gridColumn: '2 / span 10',
                aspectRatio: '16 / 9',
            },
        }),
        image: () => ({
            [breakpoints.md]: {
                aspectRatio: '2.4 / 1',
            },
        }),
    })
);

export const StyledCaption = styled(Text)(({ theme }) => ({
    marginTop: theme.spaces[1],
    padding: `0 ${theme.spaces[1]}`,

    [breakpoints.md]: {
        padding: 0,
    },
}));
